import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col-reverse justify-end h-full relative" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = { class: "flex items-baseline gap-x1" }
const _hoisted_4 = { class: "relative mb-8" }
const _hoisted_5 = { class: "absolute inset-x-0 inset-y-x2" }
const _hoisted_6 = { class: "absolute left-0 flex flex-col gap-y-8" }
const _hoisted_7 = { class: "absolute bottom-0 left-0 right-0 flex items-end justify-between sm:gap-x-15" }

import ProductSpotImage from '@/shared/product/spot/ui/ProductSpotImage.vue';
import ProductSpotPrice from '@/shared/product/spot/ui/ProductSpotPrice.vue';
import ProductSpotFreightInformation from '@/shared/product/spot/ui/ProductSpotFreightInformation.vue';
import ProductSpotCertifications from '@/shared/product/spot/ui/ProductSpotCertifications.vue';
import ProductSpotEnergyClassification from '@/shared/product/spot/ui/ProductSpotEnergyClassification.vue';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import PDPLink from '@/shared/navigation/PDPLink.vue';
import ProductSpotTitle from '@/shared/product/spot/ui/ProductSpotTitle.vue';
import { ProductLabelType, ProductSpotModel } from '@/types/productServerApi';
import ProductSplashLabelProductSpot from '@/shared/product/splash/ui/ProductSplashLabelProductSpot.vue';
import ProductSplashLabelNewArrival from '@/shared/product/splash/ui/ProductSplashLabelNewArrival.vue';
import ProductSplashLabelCustomize from '@/shared/product/splash/ui/ProductSplashLabelCustomize.vue';
import { computed } from 'vue';
import ProductNetPrice from '@/b2b/product/ui/ProductNetPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpot',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: ProductSpotModel;
}



const productSpotLabel = computed(() => props.product.labels?.find((label) => label.type === ProductLabelType.ProductSpot));
const newArrivalLabel = computed(() => props.product.labels?.find((label) => label.type === ProductLabelType.NewArrival));
const customizeLabel = computed(() => props.product.labels?.find((label) => label.type === ProductLabelType.Customize));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(PDPLink, {
      sku: __props.product.sku,
      title: __props.product.name,
      class: "absolute inset-0 z-1"
    }, null, 8, ["sku", "title"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ProductSpotTitle, {
          name: __props.product.name,
          designer: __props.product.designerName
        }, null, 8, ["name", "designer"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProductSpotPrice, {
          price: __props.product.price,
          "from-price": __props.product.fromPrice
        }, null, 8, ["price", "from-price"]),
        (__props.product.sku)
          ? (_openBlock(), _createBlock(ProductNetPrice, {
              key: 0,
              "variant-id": __props.product.sku
            }, null, 8, ["variant-id"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ProductSpotFreightInformation, {
        sku: __props.product.sku
      }, null, 8, ["sku"]),
      _createVNode(Breakpoints, null, {
        "max-xs": _withCtx(() => [
          _createVNode(ProductSpotEnergyClassification, {
            class: "mt-15",
            "lighting-specification": __props.product.lightingSpecification
          }, null, 8, ["lighting-specification"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ProductSpotImage, { product: __props.product }, null, 8, ["product"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ProductSplashLabelProductSpot, { label: _unref(productSpotLabel) }, null, 8, ["label"]),
          _createVNode(ProductSplashLabelNewArrival, { label: _unref(newArrivalLabel) }, null, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ProductSplashLabelCustomize, { label: _unref(customizeLabel) }, null, 8, ["label"]),
          _createVNode(Breakpoints, null, {
            "min-sm": _withCtx(() => [
              _createVNode(ProductSpotEnergyClassification, {
                "lighting-specification": __props.product.lightingSpecification
              }, null, 8, ["lighting-specification"])
            ]),
            _: 1
          }),
          (__props.product.certificates)
            ? (_openBlock(), _createBlock(ProductSpotCertifications, {
                key: 0,
                class: "ml-auto",
                certificates: __props.product.certificates
              }, null, 8, ["certificates"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})